import type { RouteObject } from 'react-router';

import { ROUTES } from '@/constants/routes';

/** Every staff account has Settings; it needs no permission. */
export const settingsRoutes: RouteObject[] = [
  {
    path: ROUTES.SETTINGS,
    lazy: async () => ({ Component: (await import('./pages/SettingsPage')).SettingsPage }),
  },
];
